import { render } from "./RadioField.vue?vue&type=template&id=27b5dbf2&scoped=true"
import script from "./RadioField.vue?vue&type=script&lang=js"
export * from "./RadioField.vue?vue&type=script&lang=js"

import "./RadioField.vue?vue&type=style&index=0&id=27b5dbf2&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b5dbf2"]])

export default __exports__
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QOptionGroup,QRadio});
